(function () {
  var state = { initialized: false, observers: [] };

  function headerElement() {
    return document.getElementById('shopify-section-header');
  }

  function topHeaderElement() {
    return document.querySelector('#shopify-section-header .top-header');
  }

  function setHeightVariable(name, element) {
    if (!element) return;
    var height = element.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty(name, height + 'px');
    }
  }

  function sync() {
    setHeightVariable('--luxster-header-height', headerElement());
    setHeightVariable('--luxster-top-header-height', topHeaderElement());
  }

  function syncSoon() {
    sync();
    [0, 50, 150, 300, 600].forEach(function (delay) {
      window.setTimeout(sync, delay);
    });
  }

  function init() {
    if (state.initialized) {
      syncSoon();
      return;
    }
    state.initialized = true;
    syncSoon();

    if (window.ResizeObserver) {
      [headerElement(), topHeaderElement()].forEach(function (element) {
        if (!element) return;
        var observer = new ResizeObserver(syncSoon);
        observer.observe(element);
        state.observers.push(observer);
      });
    }

    window.addEventListener('resize', syncSoon);
    window.addEventListener('load', syncSoon, { once: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncSoon);
    }
  }

  window.LuxsterHeaderHeightSync = { init: init, sync: sync };
})();